module.exports = __webpack_public_path__ + "img/environmentalMonitoring02.e99fe480.png";